




import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CHECK_DEVICE_WHITELISTED, CREATE_IP_ADDRESS,  DELETE_IP_ADDRESS, GET_IP_ADDRESS, UPDATE_IP_ADDRESS, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetIpAddressSecurty = createAsyncThunk('getIpAddress', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_IP_ADDRESS, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetIpAddressSecurtySlice = createSlice({
    name: 'Ip Address',
    initialState: {
        IpAddress: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetIpAddressSecurty.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetIpAddressSecurty.fulfilled, (state, action) => {
                state.IpAddress = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetIpAddressSecurty.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetIpDeviceAddressDetails = createSlice({
    name: 'Ip Address',
    initialState: {
        DeviceDetails: ''
    },
    reducers: {
        settDeviceIpDetails: (state, action) => {
            state.DeviceDetails = action.payload;
        }
    }
});

export const AddDeviceIpAddress = createAsyncThunk('CreateIp', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_IP_ADDRESS, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateAddressIp = createAsyncThunk('updatIp', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_IP_ADDRESS, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteIpAddress = createAsyncThunk('deletIp', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_IP_ADDRESS, { IPWhitelistID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessag)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});


// check Device White Listed Ip  --------
export const checkDeviceWhiteListed = createAsyncThunk('CheckDeviceIp', async (_, { rejectWithValue }) => {

    try {

        // await new Promise(resolve => setTimeout(resolve, 100));
        const response = await FetchData(CHECK_DEVICE_WHITELISTED, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            // Toast('success', response?.data?.apiStatus?.statusMessage)

            return { status: response.data?.apiStatus?.statusCode, messag: 'ok' }
        } else if (response.status === 401) {
            return { status: response.status }
        } else {
            return { status: response.status }
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const CheckDeviceWhiteListedSlice = createSlice({
    name: 'Check Device Ip',
    initialState: {
        status: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkDeviceWhiteListed.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(checkDeviceWhiteListed.fulfilled, (state, action) => {
                state.IpAddress = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(checkDeviceWhiteListed.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


export const { settDeviceIpDetails } = GetIpDeviceAddressDetails.actions
export {
    GetIpAddressSecurtySlice,
    GetIpDeviceAddressDetails,
    CheckDeviceWhiteListedSlice
};
